import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SITE, COMPLETED_PROJECTS } from "../data/site";
import { SERVICES, SERVICE_LIST } from "../data/services";
import { usePageMeta } from "../hooks/usePageMeta";

export default function ServicesHub() {
  usePageMeta({
    title: "Services | Swift Luxury Walls — Custom Media Walls, Accent Walls & Built-Ins",
    description:
      "Custom media walls, accent walls, wood slat installations, electric fireplace walls and built-in cabinetry — designed and installed across Tampa Bay by Swift Luxury Walls.",
    canonicalPath: "/services",
  });

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-24 pb-16 grain">
      <div className="container-x px-5 md:px-10 lg:px-16">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#A1A1AA] mb-6">
          <Link to="/" className="hover:text-[#D4AF37]">Home</Link>{" "}
          / <span className="text-[#D4AF37]">Services</span>
        </div>

        <div className="max-w-3xl">
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37]">Everything we build</div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight mt-3">
            Custom walls for every room of your home.
          </h1>
          <p className="text-sm md:text-base text-[#D1D1D6] mt-5 leading-relaxed">
            From full media walls to a single feature installation — we design, fabricate and install each project
            with the same standard. Pick a service to see what's included, materials we work with, and how we get
            from consult to finish.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/design-my-wall" className="btn-gold !py-3 !px-6">
              Design My Wall <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={`tel:${SITE.phoneDigits}`} className="btn-ghost !py-3 !px-6">
              <Phone className="w-4 h-4" /> Call {SITE.phone}
            </a>
          </div>
        </div>

        <section className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICE_LIST.map((slug, i) => {
            const s = SERVICES[slug];
            const img = COMPLETED_PROJECTS.find((p) => p.id === s.hero_image) || COMPLETED_PROJECTS[i % COMPLETED_PROJECTS.length];
            return (
              <Link
                key={slug}
                to={`/services/${slug}`}
                data-testid={`service-card-${slug}`}
                className="group rounded-2xl overflow-hidden border border-[#27272A] hover:border-[#AA8035] transition-colors bg-[#0d0d0d]"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={img.src}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-5">
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37]">{s.overline}</div>
                  <div className="font-display text-2xl text-white mt-1">{s.title}</div>
                  <div className="text-xs text-[#A1A1AA] mt-2 line-clamp-2">{s.hero_sub}</div>
                  <div className="text-[11px] tracking-wide text-[#D4AF37] mt-4 inline-flex items-center gap-1">
                    View service <ArrowRight className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            );
          })}
        </section>
      </div>
    </div>
  );
}
